import TR from 'utils/TR';
import { Chart } from 'chart.js';
import Section from 'components/common/Section';
import PagingIndicator from 'components/common/paging/PagingIndicator';
import defaultRenderNextButtons from 'components/common/paging/defaultRenderNextButtons';
import defaultRenderPrevButtons from 'components/common/paging/defaultRenderPrevButtons';
import DIRECTION_VERTICAL from 'constants/DIRECTION_VERTICAL';
import usePaging from 'hooks/tables/usePaging';
import React from 'react';
import T from 'utils/T';
import ex from 'utils/ex';

import useReportActiveStatDayList from 'hooks/communication/useReportActiveStatDayList';

import Recoil from 'recoil';
import * as AppStore from 'stores/AppStore';
import * as Luxon from 'luxon';
import { luxonClone } from 'utils/time';
import ExerciseStatisticsChart from './ExerciseStatisticsChart';
import DialogButton from 'components/common/DialogButton';
import ExerciseDialog from 'components/dialogs/ExerciseDialog';
import { numberWithComma } from 'utils/number';
import useSetChartData from 'hooks/app/useSetChartData';
import WEEK_DAY_COLUMNS from 'constants/WEEK_DAY_COLUMNS';
import HBox from 'components/common/HBox';
const PAGE_ROW_CNT = 5

export default function ExerciseStatistics(props) {
  const {
    viewMode,
    category,
    duration,
    ...rest
  } = props || {};

  const {
    page,
    onPage,
    npage,
    onNPage,
    maxPage,
    onMaxPage
  } = usePaging({
    resetCondition: [],
    defaultMaxPage: 6,
  });

  const {
    requestReportActiveStatDayList,
  } = useReportActiveStatDayList();

  const setChartData = useSetChartData('ExerciseDailyStatisticsList');
  const [list, setList] = React.useState([]);

  const period_start = Recoil.useRecoilValue(AppStore.assets.period_start);
  const period_end = Recoil.useRecoilValue(AppStore.assets.period_end);
  const patient_no = Recoil.useRecoilValue(AppStore.assets.patient_no);

  React.useEffect(() => {
    requestReportActiveStatDayList({
      patient_no,
      search_start_time: period_start,
      search_end_time: period_end,
      page_row_cnt: PAGE_ROW_CNT,
      page_no: npage,
    }, (success, data) => {
      if (success) {
        setChartData(() => ({ list: data.daily_active_page_list }));
        setList(() => data.daily_active_page_list)
        onMaxPage(data.max_page_no);
        onPage(data.page_no);
      } else {
        setChartData(() => ({ list: [] }));
        setList(() => []);
        onMaxPage(1);
        onPage(1);
        onNPage(1);
      }
    });
  }, [npage, onMaxPage, onNPage, onPage, patient_no, period_end, period_start, requestReportActiveStatDayList, setChartData]);

  return (
    <Section
      {...ex('ExerciseStatistics', rest)}
      {...{
        caption: T('일별 통계'),
        direction: DIRECTION_VERTICAL,
      }}
    >
      <div>
        <ExerciseStatisticsChart {...props} />
      </div>
      <div>
        <table>
          <thead>
            <tr>
              <th>
                <div>
                  {T('날짜')}
                </div>
              </th>
              <th>
                <div>
                  {viewMode === 'ReportExerciseSteps' && T('걸음수 (보)')}
                  {viewMode === 'ReportExerciseCalories' && T('소모칼로리 (kcal)')}
                </div>
              </th>
              <th>
                <div>
                  {T('활동시간 (분)')}
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {list.map((item, index) => {
              const {
                date,
                step_cnt,
                active_time,
                burned_calorie,
              } = item;
              const luxon = Luxon.DateTime.fromFormat(date, 'yyyyMMdd');
              const weekday = luxonClone(luxon).weekday
              return (
                <tr key={index}>
                  <td>
                    <div>
                      <DialogButton
                        {...{ category: 'App' }}
                        {...ex('ExerciseDialogButton')}
                        {...{ label: T('{0} ({1})', luxon.toFormat('yy.MM.dd'), WEEK_DAY_COLUMNS[weekday - 1]) }}
                      >
                        <ExerciseDialog
                          {...{
                            luxon,
                          }}
                        />
                      </DialogButton>
                    </div>
                  </td>
                  <td>
                    <HBox center>
                      {viewMode === 'ReportExerciseSteps' && numberWithComma(step_cnt).padStart(8, '⠀')}
                      {viewMode === 'ReportExerciseCalories' && numberWithComma(burned_calorie).padStart(8, '⠀')}
                    </HBox>
                  </td>
                  <td>
                    <HBox center>
                      {numberWithComma(active_time).padStart(8, '⠀')}
                    </HBox>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <PagingIndicator
          {...{
            indicatorCount: 5,
            maxPage,
            page,
            onNPage,
            renderPrevButtons: defaultRenderPrevButtons,
            renderNextButtons: defaultRenderNextButtons,
          }}
        />
      </div>
    </Section>
  );
}
